import { User } from '../@types/common.types';
import { UserRole } from '../enums/shared.enums';

export function firstNameLastInitial(client: User) {
    if (!client) {
        return '';
    }

    if (client.firstName && client.lastName) {
        return `${client.firstName} ${client.lastName[0]}.`;
    }

    const terms = client.name.split(' ');
    if (terms.length === 1) {
        return terms[0];
    }
    return `${terms[0]} ${terms[1][0]}.`;
}

export function roleBasedName(user: User, viewer?: User | null) {
    if (viewer?.role.isAdmin || viewer?.role.name === UserRole.CLIENT) {
        return user.name;
    }
    return firstNameLastInitial(user);
}

// List of words that should not be capitalized
const lowerCaseWords = [
    'a',
    'an',
    'and',
    'as',
    'at',
    'but',
    'by',
    'for',
    'in',
    'nor',
    'of',
    'on',
    'or',
    'so',
    'the',
    'to',
    'up',
    'yet',
];

export function toProperCase(str: string, split = ' ') {
    if (!str) {
        return '';
    }
    return str
        .toLowerCase()
        .split(split)
        .map((word, i) => {
            if (i === 0) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }
            if (lowerCaseWords.includes(word)) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
}

export function firstLetterUpperCase(str: string) {
    if (!str) {
        return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getLastTerm(str: string, split = ' ') {
    if (!str) {
        return '';
    }
    return str.split(split).pop();
}
